import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import {
  AutoCompleteExtraProps,
  EditableTableFieldProps,
  FormFieldDefinitionType,
  FormHandles,
} from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IntegrationFormTypes } from "models/formTypes";
import { BillogramFormProps } from "models/propTypes/integrationsPropTypes";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const BillogramForm: ForwardRefRenderFunction<FormHandles, BillogramFormProps> = (props, ref) => {
  return (
    <GenericForm<IntegrationFormTypes.Billogram>
      formRef={ref}
      {...props}
      fields={{
        useBillogram: {
          label: TranslationKeys.Integrations.UseBillogram,
          type: FormEnums.FormFieldType.TOGGLE,
          classes: { formControl: cssExports.inlineLabel },
        },
        useBillogramDescription: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          customField: (
            <Grid container className={cssExports.formControlDescription}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Integrations.UseBillogramDescription)}
            </Grid>
          ),
        },
        billogramAuthUser: {
          label: TranslationKeys.Integrations.UserName,
          type: FormEnums.FormFieldType.TEXT,
          hidden: (values: IntegrationFormTypes.Billogram) => !values.useBillogram,
        },
        billogramAuthKey: {
          label: TranslationKeys.Login.Password,
          type: FormEnums.FormFieldType.TEXT,
          hidden: (values: IntegrationFormTypes.Billogram) => !values.useBillogram,
        },
        billogramAccountMappingDetails: {
          label: "",
          type: FormEnums.FormFieldType.CUSTOM,
          hidden: (values: IntegrationFormTypes.Billogram) => !values.useBillogram,
          customField: (
            <>
              <Grid container className={cssExports.formControlLabel}>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Integrations.BillogramAccountDimensions
                )}
              </Grid>
              <Grid container className={cssExports.formControlDescription}>
                {LocalizationHelperInstance.getFormattedMessage(
                  TranslationKeys.Integrations.BillogramAccountDimensionsDescription
                )}
              </Grid>
            </>
          ),
        },
        billogramAccountMappingListItems: {
          label: "",
          type: FormEnums.FormFieldType.EDITABLETABLE,
          hidden: (values: IntegrationFormTypes.Billogram) => !values.useBillogram,
          innerFields: {
            accountNumber: {
              label: "",
              placeholder: TranslationKeys.Settings.AccountNumber,
              type: FormEnums.FormFieldType.NUMBER,
              widthColumnCount: 3,
              classes: { input: cssExports.compactTableLeftAlignField },
            },
            constCenterName: {
              label: "",
              type: FormEnums.FormFieldType.AUTOCOMPLETE,
              placeholder: TranslationKeys.Settings.CostCenter,
              classes: { input: cssExports.compactTableLeftAlignField },
              extraProps: {
                referenceFieldName: FormFieldConstants.Integration.BillogramAccountMappingListItem.CostCenterId,
                items: props.costCenterDimensions.map((item) => ({
                  id: item.id,
                  value: item.name,
                })),
              } as AutoCompleteExtraProps<IntegrationFormTypes.BillogramAccountMappingListItem>,
            },
            projectName: {
              label: "",
              placeholder: TranslationKeys.Settings.Project,
              type: FormEnums.FormFieldType.AUTOCOMPLETE,
              classes: { input: cssExports.compactTableLeftAlignField },
              extraProps: {
                referenceFieldName: FormFieldConstants.Integration.BillogramAccountMappingListItem.ProjectId,
                items: props.projectDimensions.map((item) => ({
                  id: item.id,
                  value: item.name,
                })),
              } as AutoCompleteExtraProps<IntegrationFormTypes.BillogramAccountMappingListItem>,
            },
          } as FormFieldDefinitionType<IntegrationFormTypes.BillogramAccountMappingListItem>,
          extraProps: {
            defaultRow: {},
            isCompactTable: true,
            idFieldKey: FormFieldConstants.Integration.BillogramAccountMappingListItem.Key,
          } as EditableTableFieldProps<IntegrationFormTypes.BillogramAccountMappingListItem>,
        },
      }}
    />
  );
};

export default forwardRef(BillogramForm);
